import { SGUID_EMPTY_CONST, isNullOrWhitespace } from "@utils/common";
import { BetOffer } from "@models";

export const prepareOfferData = (bet: {
	betSlipOffers:
		| {
				eventId: string;
				isMulti: boolean;
				multiEventName: string;
				multiOffers: BetOffer[];
		  }[]
		| any;
}) => {
	const offers = bet.betSlipOffers ?? [];

	const grouped: Record<string, any[]> = {};

	for (const offer of offers) {
		if (!grouped[offer.eventId]) {
			grouped[offer.eventId] = [];
		}
		grouped[offer.eventId].push(offer);
	}

	for (const eventId in grouped) {
		const group = grouped[eventId];

		if (group.length > 1) {
			for (let i = 1; i < group.length; i++) {
				group[i].isMulti = true;
				group[i].multiEventName = `${i + 1} Multi`;
			}
		}
	}

	return Object.values(grouped).flat();
};

export const getTeamNames = (offer: {
	playerId: string | null;
	playerFirstName: string | null;
	playerLastName: string | null;
	teamId: string | null;
	teamName: string | null;
	bettingTypeTip: string | null;
}) => {
	if (
		!isNullOrWhitespace(offer.playerId) &&
		offer.playerId != SGUID_EMPTY_CONST
	) {
		return `${offer.playerFirstName}, ${offer.playerLastName}`;
	} else if (
		!isNullOrWhitespace(offer.teamId) &&
		offer.teamId != SGUID_EMPTY_CONST
	) {
		return offer.teamName;
	}
	return offer.bettingTypeTip;
};

export const getParsedCurrentResult = (offer: {
	currentResult: string | null;
}):
	| (Parameters<typeof getCurrentResult>[0] &
			Parameters<typeof getCurrentScorePerPeriod>[1])
	| null => {
	if (
		offer.currentResult != null &&
		!isNullOrWhitespace(offer.currentResult)
	) {
		return JSON.parse(offer.currentResult);
	}
	return null;
};

export const getParsedResult = (
	offer: { sportData?: { result?: string | null } } | null | undefined
): object | null => {
	if (
		offer?.sportData?.result != null &&
		!isNullOrWhitespace(offer.sportData.result)
	) {
		return JSON.parse(offer.sportData.result);
	}
	return null;
};

export const getScorePerPeriod = (
	parsedResult: { scorePerPeriod?: { home?: number; away: number }[] } | null
) => {
	if (parsedResult != null && parsedResult.scorePerPeriod != null) {
		return parsedResult.scorePerPeriod
			.map((period) => `${period.home || 0}:${period.away || 0}`)
			.join("; ");
	}
	return "";
};

export const getCurrentResult = (
	parsedCurrentResult:
		| {
				currentScore?: { home?: number; away?: number };
				home?: null | undefined;
				away?: null | undefined;
		  }
		| { home?: number; away?: number; currentScore?: null | undefined }
		| null
		| undefined,
	sportAbrv?: string | null | undefined
): string => {
	if (sportAbrv == "cricket") {
		//@ts-expect-error
		const spp = parsedCurrentResult.scorePerPeriod;
		if (spp) {
			if (spp.length > 1) {
				return `${spp[0].home || 0}/${spp[1].home || 0} : ${spp[0].away || 0}/${spp[1].away || 0}`;
			} else {
				return `${spp[0].home || 0}:${spp[0].away || 0}`;
			}
		} else {
			return "0:0";
		}
	}

	if (
		parsedCurrentResult != null &&
		parsedCurrentResult.currentScore != null
	) {
		return `${parsedCurrentResult.currentScore.home || 0}:${
			parsedCurrentResult.currentScore.away || 0
		}`;
	} else if (parsedCurrentResult != null) {
		return `${parsedCurrentResult.home || 0}:${
			parsedCurrentResult.away || 0
		}`;
	}
	return "";
};

export const getCurrentScorePerPeriod = (
	currentResult: unknown | null | unknown,
	parsedCurrentResult: {
		scorePerPeriod?: { home?: number; away?: number }[] | null | undefined;
	} | null
) => {
	let currentScorePerPeriod = "";
	if (currentResult != null && parsedCurrentResult?.scorePerPeriod != null) {
		for (let i = 0; i < parsedCurrentResult.scorePerPeriod.length; i++) {
			currentScorePerPeriod += `${i != 0 ? " " : ""}(${
				parsedCurrentResult.scorePerPeriod[i].home || 0
			}:${parsedCurrentResult.scorePerPeriod[i].away || 0})`;
		}
	}
	return currentScorePerPeriod;
};

export const getSystemString = ({
	system,
	combinationBettingOffersBankCount,
	eventCount,
	combinationBettingOffersCount,
}: {
	system: string;
	combinationBettingOffersBankCount: number;
	eventCount: number;
	combinationBettingOffersCount: number;
}) => {
	if (combinationBettingOffersBankCount > 0) {
		return `(B x ${combinationBettingOffersBankCount}, ${system} / ${
			eventCount - combinationBettingOffersBankCount
		} = ${combinationBettingOffersCount})`;
	}
	return `(${system} / ${
		eventCount - combinationBettingOffersBankCount
	} = ${combinationBettingOffersCount})`;
};

export const ACCOUNT_STATEMENT_DEFAULT_FILTER = {
	asPeriod: "today",
	asType: "all",
};
